import React, { useRef } from "react";
import { Col, Container, Button, Row } from "react-bootstrap";

import "./AboutMe.css";

const AboutMe = () => {
  const ref = useRef(null);
  React.useEffect(() => {
    import("@lottiefiles/lottie-player");
  });
  return (
    <div className="About" id="about">
      <Container data-aos="fade-left">
        <Row>
          <Col className="aboutme" xs={12} md={6}>
            <h3>front-end web developer</h3>
            <p>
              Bachelor’s degree at Computer and Information Sciences, I am
              always seeking to enhance my technical to increase my knowledge
              and my experts
            </p>
            <Row>
              <Col xs={12} md={6}>
                <ul className="about-info" data-aos="fade-left">
                  <li>
                    <span>Name:</span>
                    <span className="details">Mahmoud Ashraf </span>
                  </li>
                  <li>
                    <span>Date of birth:</span>
                    <span className="details">March 16,1998 </span>
                  </li>
                </ul>
              </Col>
              <Col>
                <ul className="about-info" data-aos="fade-left">
                  <li>
                    <span>phone:</span>
                    <span className="details">01095691698 </span>
                  </li>
                  <li>
                    <span>Address:</span>
                    <span className="details">Cairo,Egypt </span>
                  </li>
                  <li>
                    <br />
                    <Button
                      className="btn-get-cv"
                      variant="outline-light"
                      onClick={() =>
                        window.open(
                          "https://drive.google.com/file/d/1Wl9ieVyVXJXF23B4sJoB-7kwZsbPgosP/view?usp=sharing"
                        )
                      }
                    >
                      Download CV
                    </Button>
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6} className="anima-side">
            <lottie-player
              id="firstLottie"
              ref={ref}
              autoplay
              loop
              mode="normal"
              src="https://assets9.lottiefiles.com/packages/lf20_63khtdzj.json"
            ></lottie-player>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default AboutMe;
